import * as React from 'react'

import { useMediaQuery } from '@buffer-mono/popcorn'

import type { JSX } from 'react'

/**
 * Marks a route subtree as able to host the Idea Composer inline as a side
 * panel. Pages that lay the composer routes out next to their content (the
 * Ideas list view) provide this; everywhere else the composer stays a dialog.
 */
const IdeaComposerPanelContext = React.createContext(false)

export const IdeaComposerPanelProvider = ({
  children,
}: {
  children: React.ReactNode
}): JSX.Element => (
  <IdeaComposerPanelContext.Provider value={true}>
    {children}
  </IdeaComposerPanelContext.Provider>
)

/**
 * Resolves how the Idea Composer presents itself: inline side panel when the
 * surrounding page supports it and the screen is wide enough for the list
 * and the composer to sit side by side, dialog otherwise.
 */
export const useIdeaComposerVariant = (): 'panel' | 'dialog' => {
  const isPanelCapable = React.useContext(IdeaComposerPanelContext)
  const isWideScreen = useMediaQuery('(width > 1280px)')
  return isPanelCapable && isWideScreen ? 'panel' : 'dialog'
}
